import { apiClient } from '@/services';
import type { ApiResponse } from './types';
import type { CreateAssetData } from './types';
import { createAssetSchema } from './types';

export type { CreateAssetData } from './types';

export async function createAsset(data: CreateAssetData): Promise<ApiResponse<any>> {
  const validatedData = createAssetSchema.parse(data);

  // Clean up empty strings for optional fields
  const payload: any = { ...validatedData };
  if (payload.marketCap === '' || payload.marketCap == null) {
    payload.marketCap = undefined;
  }
  if (payload.comment === '' || payload.comment == null) {
    payload.comment = undefined;
  }

  const response = await apiClient.post<any>('/api/assets', payload);

  return response;
}
